import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[setInputMaxAttribute]'
})
export class MaxValueDirective {
    @Input('MaxType') type: string;

    private getMaxValue(): number {
        switch (this.type) {
            case 'percentage':
                return 100;
            case 'ratio':
                return 999.99;
            case 'production':
                return 9999999;
            default:
                return 999.99; // Default max value
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {

        // Allow: Ctrl+V
        if ((event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 88) && event.ctrlKey === true) {
            return;
        }

        const maxValue = this.getMaxValue();
        const inputValue = parseFloat((event.target as HTMLInputElement).value.replace(/,/g, ''));
        const key = event.key;

        // Allow: backspace, delete, tab, escape, enter, and .
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (event.keyCode === 65 && event.ctrlKey === true) ||
            // Allow: Ctrl+C
            (event.keyCode === 67 && event.ctrlKey === true) ||
            // Allow: Ctrl+X
            (event.keyCode === 88 && event.ctrlKey === true) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // Let it happen, don't do anything
            return;
        }

        // Ensure that it is a number and stop the keypress if not
        const regex = new RegExp("^[0-9\.]+$");
        if (!regex.test(key)) {
            event.preventDefault();
            return;
        }

        // Get the current cursor position
        const cursorPos = (event.target as HTMLInputElement).selectionStart;

        // Get the parts of the value before and after the cursor
        const preCursorVal = (event.target as HTMLInputElement).value.slice(0, cursorPos);
        const postCursorVal = (event.target as HTMLInputElement).value.slice(cursorPos);

        // Construct the potential new value of the input field
        let newVal = preCursorVal + key + postCursorVal;
        const num = parseFloat(newVal.replace(/,/g, ''));
        // if(this.type == 'production'){
        //     newVal = preCursorVal + key + postCursorVal;
        // }
        // else{
        //     newVal = parseFloat(preCursorVal + key + postCursorVal);
        // }
        

        // If the new value is greater than the max value, prevent the keypress
        if (num > maxValue) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        const maxValue = this.getMaxValue();
        let pasteData = event.clipboardData?.getData('text');
        pasteData = pasteData.replace(/,/g, ''); // Remove commas
        if (pasteData && parseFloat(pasteData) > maxValue) {
            event.preventDefault();
            (event.target as HTMLInputElement).value = null;
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const maxValue = this.getMaxValue();
        const inputElement = event.target as HTMLInputElement;
        const inputValue = parseFloat(inputElement.value.replace(/,/g, ''));

        if (inputValue > maxValue) {
            inputElement.value = null;
        }
    }
}